module.exports = __webpack_public_path__ + "static/intro_4x5-5238188f6efdc5eee6597c1cc2b8bd74.mp4";